export default {
  common: {
    edited: 'Editado',
    error: {
      general: '¡Ups!',
      failedToOpenMaps: 'Error al abrir el mapa',
      failedToOpenLink:
        'Error al abrir el enlace. No hay ningún navegador web disponible en este dispositivo.',
      reportTooMany: 'Has enviado muchas denuncias recientemente. Espera un poco e inténtalo de nuevo.',
      reportFailed: 'No pudimos abrir el formulario de denuncia. Inténtalo de nuevo.',
      reportUnavailable: 'Este contenido ya no está disponible para denunciar.',
      popupBlocked:
        'Tu navegador bloqueó la apertura del formulario. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.',
      ipBlocked:
        'Tu dirección IP ha sido bloqueada debido a actividad sospechosa. Si crees que esto es un error, ponte en contacto con el soporte.',
      crashTitle: '¡Ups! Algo salió mal',
      crashSubtitle: 'Ya hemos sido notificados y estamos investigando.',
      crashReload: 'Recargar',
      crashRetry: 'Reintentar',
    },
    updateBanner: {
      message: 'Hemos hecho algunas mejoras',
      refresh: 'Recargar',
    },
    connection: {
      offline: 'Sin conexión a internet',
      connecting: 'Conectando...',
    },
    success: '¡Éxito!',
    follow: 'Seguir',
    unfollow: 'Dejar de seguir',
    followed: 'Siguiendo',
    message: 'Mensaje',
    empty: 'Nada que ver aquí todavía',
    post: 'publicación',
    comment: 'comentario',
    photo: 'foto',
    month: 'mes',
    year: 'año',
    cancel: 'Cancelar',
    continue: 'Continuar',
    back: 'Atrás',
    delete: 'Eliminar',
    update: 'Actualizar',
    saveChanges: 'Guardar cambios',
    scrollToTop: 'Ir arriba',
    undo: 'Deshacer',
    report: 'Reportar',
    openingForm: 'Abriendo el formulario...',
    accept: 'Aceptar',
    reject: 'Rechazar',
    retry: 'Reintentar',
    send: 'Enviar',
    unblock: 'Desbloquear',
    comingSoon: 'Próximamente',
    loading: 'Cargando...',
    done: 'Listo',
    clear: 'Borrar',
    clearAll: 'Restablecer',
    search: 'Buscar...',
    share: {
      success: 'Compartido exitosamente',
      error: 'Error al compartir',
      copied: 'Enlace copiado al portapapeles',
      shareLink: 'Compartir enlace',
      url: 'URL',
      copy: 'Copiar',
      open: 'Abrir',
    },
    validation: {
      min: 'Debe tener al menos {{minLength}} caracteres',
      max: 'Debe tener como máximo {{maxLength}} caracteres',
      required: 'Este campo es obligatorio',
      requiredField: '{{field}} es obligatorio',
    },
    filters: {
      myType: 'mi tipo',
      all: 'filtros',
    },
    relativeTime: {
      now: 'ahora',
      justNow: 'ahora mismo',
    },
  },
  myTypeFilter: {
    title: 'Filtro Mi Tipo',
    enableOption: 'Activar',
    disableOption: 'Desactivar',
    statusEnabled: 'Activo',
    statusDisabled: 'Inactivo',
    configure: 'Configurar…',
    configureTitle: 'Configurar Filtro Mi Tipo',
    enabled: 'Filtro Mi Tipo activado',
    disabled: 'Filtro Mi Tipo desactivado',
    enableError: 'Error al activar el filtro',
    disableError: 'Error al desactivar el filtro',
    infoTitle: '¿Qué es el Filtro Mi Tipo?',
    infoDescription:
      'Configura tus preferencias una vez y las listas de publicaciones, miembros y fotos mostrarán automáticamente solo personas que coincidan con tus criterios. Puedes activar o desactivar este filtro en cualquier momento.',
    preview: 'Vista previa',
    apply: 'Aplicar',
    appliedSuccess: 'Configuración del filtro guardada',
    appliedError: 'Error al guardar la configuración del filtro',
    filteredOutPercent: '{{percent}}% de miembros filtrados',
    filterWarning: 'Filtrar a demasiadas personas puede afectar tu experiencia.',
  },
  sensitiveContent: {
    title: 'Contenido Sensible',
    statusHidden: 'Oculto',
    statusVisible: 'Visible',
    configure: 'Configurar...',
  },
  navigation: {
    feeds: 'Feeds',
    people: 'Miembros',
    photo: 'Foto',
    photos: 'Fotos',
    events: 'Eventos',
    discover: 'Descubrir',
  },
  communities: {
    myCommunities: 'Mis comunidades',
    menu: {
      remove: 'Quitar de Mis comunidades',
    },
    delete: {
      confirmTitle: 'Quitar comunidad',
      confirmMessage:
        '¿Seguro que quieres quitar {{communityName}} de Mis comunidades? Puedes iniciar sesión de nuevo más tarde.',
      success: 'Comunidad quitada',
      error: 'Error al quitar la comunidad',
    },
    visitSite: 'Visitar {{communityName}}',
  },
  auth: {
    createAccount: 'Crear cuenta',
    signIn: {
      title: 'Iniciar sesión',
      welcomeBack: '¡Bienvenido de nuevo!',
      heading: 'Inicia sesión en {{communityName}}',
      usernameLabel: 'Nombre de usuario',
      usernamePlaceholder: 'Ingresa el nombre de usuario',
      usernameNotFound: 'Nombre de usuario no encontrado',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Ingresa la contraseña',
      passwordIncorrect: 'Contraseña o nombre de usuario incorrectos',
      rememberMe: 'Recordarme',
      forgotPassword: '¿Olvidaste tu contraseña?',
      submit: 'Iniciar sesión',
      submitting: 'Iniciando sesión...',
      noAccount: '¿No tienes una cuenta?',
      signUp: 'Regístrate',
      loginFailedToast: 'Inicio de sesión fallido',
      removeCredentialsError: 'Error al eliminar las credenciales',
      unexpectedError: 'Ocurrió un error inesperado',
    },
    signUp: {
      redirectHelper:
        'Serás redirigido a nuestro sitio web heredado de {{communityName}} para crear una cuenta. Una vez que hayas creado una cuenta, puedes volver a esta app para iniciar sesión.',
      successToast: 'Cuenta creada. Te hemos enviado tu contraseña por correo electrónico.',
    },
    forgotPassword: {
      title: 'Olvidé mi contraseña',
      redirectHelper:
        'Serás redirigido a nuestro sitio web heredado de {{communityName}} para restablecer tu contraseña. Cuando recibas tu nueva contraseña por correo electrónico, regresa a la app para iniciar sesión.',
      successToast: 'Te hemos enviado una nueva contraseña por correo electrónico.',
    },
  },
  feeds: {
    global: 'Feed global',
    global_short: 'Global',
    local: 'Feed local',
    local_short: 'Local',
    network: 'Feed de seguidos',
    network_short: 'Seguidos',
    search: 'Búsqueda',
    search_short: 'Buscar',
    search_placeholder: 'Búsqueda en las publicaciones',
    empty: 'Lo sentimos, no hay resultados',
    latestSearches: 'Búsquedas recientes',
    popularSearches: 'Búsquedas populares',
    popularHashtags: 'Hashtags populares',
    onlineMembers: 'En línea ahora',
    profileVisitors: 'Visitaron mi perfil',
    searchMembersHint: 'Buscas a alguien?',
    searchMembersLink: 'Buscar miembros',
    pinned: 'Establecido como feed predeterminado',
    unpinned: 'Feed global restaurado como predeterminado',
    alreadyDefault: 'Este ya es tu feed predeterminado. Cambia a otro feed para modificarlo.',
    radius: {
      title: 'Radio',
      km: 'km',
      mi: 'mi',
    },
  },
  messages: {
    title: 'Mensajes',
    inbox: 'Bandeja de entrada',
    inboxBadgeUnreadCaption_one: 'sin leer',
    inboxBadgeUnreadCaption_other: 'sin leer',
    inboxBadgeMessagesCaption_one: 'mensaje',
    inboxBadgeMessagesCaption_other: 'mensajes',
    unread: 'No leídos',
    online: 'En línea',
    deleted: 'Eliminados',
    emptyDeleted: 'No hay conversaciones eliminadas en los últimos 90 días',
    search: 'Buscar',
    search_placeholder: 'Ingresa un nombre de usuario',
    empty: 'No hay mensajes para mostrar',
    conversation: 'Conversación',
    emptyConversation: 'No hay elementos de conversación para mostrar',
    typeMessage: 'Escribe un mensaje...',
    photoMessage: 'envió una foto',
    gifMessage: 'envió un GIF',
    stickerMessage: 'envió un sticker',
    clipMessage: 'envió un clip',
    youSentPhoto: 'Enviaste una foto',
    youSentGif: 'Enviaste un GIF',
    youSentSticker: 'Enviaste un sticker',
    youSentClip: 'Enviaste un clip',
    replyFailed: 'Error al enviar la respuesta',
    compose: {
      messageToUser: 'Mensaje para {{userName}}',
      enterMessage: 'Escribe tu mensaje...',
    },
    errors: {
      failedToLoad: 'Error al cargar la conversación',
      failedToSend: 'Error al enviar el mensaje',
    },
    success: {
      messageSent: 'Mensaje enviado correctamente',
    },
    loadOlderMessages: 'Cargar mensajes anteriores',
    loadingOlderMessages: 'Cargando mensajes anteriores...',
    loadingNewerMessages: 'Cargando mensajes nuevos...',
    markAsRead: {
      error: 'Error al marcar el mensaje como leído',
    },
    markAsUnread: {
      error: 'Error al marcar el mensaje como no leído',
    },
    delete: {
      success: 'Mensaje eliminado exitosamente',
      error: 'Error al eliminar el mensaje',
    },
    undelete: {
      success: 'Mensaje restaurado exitosamente',
      error: 'Error al restaurar el mensaje',
    },
    menu: {
      markRead: 'Marcar como leído',
      markUnread: 'Marcar como no leído',
      viewProfile: 'Ver perfil',
      deleteConversation: 'Eliminar conversación',
      restoreConversation: 'Restaurar conversación',
      reportConversation: 'Denunciar conversación',
    },
    copy: {
      success: 'Contenido copiado al portapapeles',
      error: 'Error al copiar el contenido',
      noContent: 'No hay contenido para copiar',
    },
    download: {
      label: 'Guardar foto',
      success: 'Foto guardada en tu biblioteca',
      error: 'No se pudo guardar la foto',
      permissionDenied: 'Se necesita permiso de la biblioteca de fotos para guardar fotos',
    },
    unreadMessage: 'Mensaje no leído',
    uploadPhoto: 'Subir imagen',
    dropImageToSend: 'Suelta la imagen para enviar',
    dropImageToSendToUser: 'Suelta la imagen para enviar a {{userName}}',
    sendPhoto: 'Enviar foto',
    photoUploadFailed: 'Error al subir la imagen',
    photoUploadSuccess: 'Imagen subida correctamente',
    selectPhoto: 'Fotos',
    takePhoto: 'Cámara',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    cameraPermissionNotGranted: 'Permiso de cámara no concedido',
    mediaLibraryPermissionNotGranted: 'Permiso de biblioteca de medios no concedido',
    failedToPickImage: 'Error al seleccionar la imagen',
    imageTooLarge: 'La imagen es demasiado grande. El tamaño máximo es {{size}}MB.',
    adminClosedInfo:
      'Esta conversación está cerrada. Para cualquier seguimiento, abre un ticket de soporte e incluye los detalles relevantes.',
    contactSupport: 'Contactar soporte',
    newAccountNotice: {
      title: '{{name}} se unió hace poco',
      body: 'Tómate tu tiempo para conocer a los nuevos miembros. Ten cuidado al compartir datos personales y desconfía si te piden pasar el chat a Telegram, WhatsApp, mensajes de texto o cualquier otro servicio de mensajería.',
    },
  },
  people: {
    nearby: 'Miembros cercanos',
    nearby_short: 'Cerca',
    online: 'Miembros en línea',
    online_short: 'En línea',
    birthdays: 'Cumpleaños',
    birthdays_short: 'Cumpleaños',
    new: 'Nuevos miembros',
    new_short: 'Nuevos',
    following: 'Miembros que sigo',
    following_short: 'Seguidos',
    followers: 'Mis seguidores',
    followers_short: 'Seguidores',
    visitors: 'Mis visitantes',
    visitors_short: 'Visitantes',
    search: 'Buscar miembros',
    search_short: 'Buscar',
    empty: 'Lo siento, esto salió vacío',
    displayModeCompact: 'Vista compacta',
    displayModeRegular: 'Vista normal',
    nearbyFilter: {
      online: 'En línea',
      recent: 'Recientes',
      active: 'Últimos 90 días',
      newmembers: 'Nuevos',
      all: 'Todos',
    },
  },
  search: {
    username: 'Nombre de usuario',
    usernamePlaceholder: 'Buscar por nombre de usuario',
    location: 'Ubicación',
    nearMe: 'Cerca de mí',
    anywhere: 'En cualquier lugar',
    customLocation: 'Ubicación personalizada',
    ranges: 'Rangos',
    age: 'Edad',
    bmi: 'IMC',
    filters: 'Filtros',
    additional: 'Filtros adicionales',
    hasPhotos: 'Tiene fotos',
    hasPrivatePhotos: 'Tiene fotos privadas',
    isOnline: 'Actualmente en línea',
    isActive: 'Activo en los últimos 90 días',
    isNew: 'Miembro nuevo',
    isFollower: 'Me sigue',
    imFollowing: 'Siguiendo',
    imTheirBodyType: 'Le interesa mi tipo de cuerpo',
    clearAll: 'Restablecer',
    search: 'Buscar',
    anything: 'Cualquier cosa',
    to: 'a',
    andUnder: 'y menos',
    andAbove: 'y más',
    multipleSelected: '{{count}} seleccionados',
    selectedCount: '{{count}} seleccionados',
    noneSelected: 'Ninguno seleccionado',
    selectAtLeastOneFilter: 'Por favor, selecciona al menos un filtro para empezar tu búsqueda',
    restoredFiltersTitle: 'Filtros restaurados',
    restoredFiltersDescription:
      'Se han restaurado los filtros de tu última búsqueda. ¿Quieres empezar de nuevo? Haz clic en el botón restablecer de abajo.',
  },
  discover: {
    seeMore: 'Ver más',
    tabBarHintLead: 'Tus pestañas tienen un menú secreto',
    tabBarHintBody: 'Mantén pulsado, desliza y salta a cualquier lista en un solo movimiento.',
    sectionSubtitles: {
      photos: {
        latest: 'Fotos públicas de la comunidad',
        network: 'Fotos públicas de miembros que sigues',
        private: 'Fotos privadas de miembros que te dejan entrar',
        favorites: 'Fotos que te gustaron',
      },
      events: {
        upcoming: 'Todos los eventos próximos de la comunidad',
        nearby: 'Eventos próximos dentro de {{distance}}',
        network: 'Eventos a los que asisten miembros que sigues',
        past: 'Eventos pasados archivados de la comunidad',
      },
    },
  },
  photos: {
    photoOf: 'Foto de {{userName}}',
    posted: 'Publicado',
    latest: 'Últimas fotos (Todos)',
    latest_short: 'Últimas',
    network: 'Últimas fotos (Seguidos)',
    network_short: 'Seguidos',
    private: 'Últimas fotos (Privadas)',
    private_short: 'Privadas',
    favorites: 'Fotos favoritas',
    favorites_short: 'Favoritas',
    addPublicPhoto: 'Agregar una foto pública',
    addPrivatePhoto: 'Agregar una foto privada',
    dropToUploadPublic: 'Suelta para subir a Público',
    dropToUploadPrivate: 'Suelta para subir a Privado',
    captionPlaceholder: 'Añade una descripción (opcional)',
    uploadSuccess: 'Foto subida',
    uploadFailed: 'Error al subir la foto',
    uploadingImage: 'Subiendo imagen...',
    policyLink: 'Lee nuestra política de fotos',
    artworkNotice:
      'Las imágenes generadas por IA deben ser identificadas como tales y publicadas con moderación.',
    artworkNoticeFerzu:
      'Las obras de arte deben ser acreditadas. Las imágenes generadas por IA no están permitidas.',
    empty: 'No hay fotos para mostrar',
    sensitiveReminder: {
      title: 'Las fotos sensibles y sin revisar están ocultas',
      body: 'Tu configuración de seguridad oculta fotos sensibles y sin revisar. Puedes cambiar esta preferencia cuando quieras en Filtros o Ajustes.',
      action: 'Revisar opciones de seguridad',
      dismiss: 'Descartar',
    },
  },
  photo: {
    menu: {
      editCaption: 'Editar descripción',
      useAsProfilePhoto: 'Usar como foto de perfil',
      moveToPrivate: 'Mover a carpeta privada',
      requestReview: 'Solicitar revisión',
      report: 'Reportar foto',
      delete: 'Eliminar foto',
    },
    caption: {
      placeholder: 'Añade una descripción (opcional)',
      updateSuccess: 'Descripción actualizada',
      updateError: 'Error al actualizar la descripción',
    },
    profile: {
      confirmTitle: 'Usar como foto de perfil',
      confirmMessage: '¿Seguro que quieres usar esta foto como tu foto de perfil?',
      setSuccess: 'Foto de perfil actualizada',
      setError: 'Error al actualizar la foto de perfil',
    },
    private: {
      success: 'Foto movida a carpeta privada',
      error: 'Error al mover la foto a carpeta privada',
    },
    locked: {
      message:
        'Actualiza tu cuenta a {{premiumPlan}} para ver fotos ilimitadas en listas y pantalla completa.',
    },
    review: {
      requestSuccess: 'Revisión solicitada',
      requestError: 'Error al solicitar revisión',
      dialogTitle: 'Clasificación de la foto',
      dialogIntro:
        'Si crees que nuestro sistema de clasificación por IA o los revisores humanos cometieron un error al determinar la clasificación de tu foto o si quieres mover una foto de tu carpeta Privada a Pública, puedes solicitar una revisión manual para que la foto sea evaluada nuevamente. Ten en cuenta que cada foto solo puede revisarse una vez y el proceso puede tardar algunas horas.',
      possibleRatingsTitle: 'Las clasificaciones posibles son:',
    },
    delete: {
      confirmTitle: 'Eliminar foto',
      confirmMessage: '¿Seguro que quieres eliminar esta foto? Esta acción no se puede deshacer.',
      success: 'Foto eliminada correctamente',
      error: 'Error al eliminar la foto',
    },
  },
  events: {
    upcoming: 'Próximos eventos',
    upcoming_short: 'Próximos',
    nearby: 'Eventos cercanos',
    nearby_short: 'Cercanos',
    network: 'Eventos de la red',
    network_short: 'Red',
    attending: 'Asistiendo',
    attend: 'Asistir',
    unattend: 'No asistir',
    follow: 'Seguir',
    following: 'Siguiendo',
    attendees: 'asistentes',
    attendees_one: 'asistente',
    attendees_other: 'asistentes',
    attendees_short: 'Asistentes',
    followers: 'seguidores',
    followers_one: 'seguidor',
    followers_other: 'seguidores',
    followers_short: 'Seguidores',
    past: 'Eventos pasados',
    past_short: 'Pasados',
    organizer: 'Organizador',
    curator: 'Curador',
    curatorNotice:
      'Esta persona ayuda a mantener los listados de eventos. Por favor, reporta cualquier inexactitud. Si eres el organizador del evento, puedes asumir esta página contactando a {{communityName}}.',
    date_time: 'Fecha y hora',
    location: 'Ubicación',
    website: 'Sitio web',
    empty: 'No hay eventos para mostrar',
    noEventsForMember: 'Aún no hay eventos',
    attendeesCount_one: '{{count}} asistente',
    attendeesCount_other: '{{count}} asistentes',
    attendSuccess: 'Estás asistiendo a este evento',
    unattendSuccess: 'Ya no asistes a este evento',
    attendError: 'No se pudo confirmar la asistencia',
    unattendError: 'No se pudo cancelar la asistencia',
    followError: 'No se pudo seguir el evento',
    unfollowError: 'No se pudo dejar de seguir el evento',
    createSuccess: 'Evento creado',
    updateSuccess: 'Evento actualizado',
    createError: 'No se pudo crear el evento',
    updateError: 'No se pudo actualizar el evento',
    deleteSuccess: 'Evento eliminado',
    deleteError: 'No se pudo eliminar el evento',
    deleteEvent: 'Eliminar evento',
    deleteConfirmTitle: '¿Eliminar evento?',
    deleteConfirmMessage:
      '¿Estás seguro de que quieres eliminar este evento? Esta acción no se puede deshacer.',
    createEvent: 'Nuevo evento',
    editEvent: 'Editar evento',
    form: {
      code: 'Código del evento',
      codePlaceholder: 'ej. mi-evento-2026',
      codeHint: 'Letras, números, guiones y guiones bajos. No puede empezar con un número.',
      name: 'Nombre del evento',
      namePlaceholder: 'Ingresa el nombre del evento',
      nameHint:
        'Evita incluir la fecha o el mes en el nombre del evento. Si lo necesitas, agrégalo al final del nombre.',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin (opcional)',
      selectDate: 'Seleccionar una fecha',
      startTime: 'Hora de inicio',
      endTime: 'Hora de fin',
      selectTime: 'Fijar hora',
      timesError: 'Fija las dos horas o ninguna',
      location: 'Ubicación',
      selectLocation: 'Seleccionar ubicación',
      venue: 'Lugar, sede u hotel',
      venuePlaceholder: 'ej. Centro de convenciones',
      website: 'Sitio web',
      websitePlaceholder: 'https://tusitioweb.com',
      websiteError: 'La URL del sitio web debe comenzar con https://',
      details: 'Detalles del evento',
      detailsPlaceholder: 'Describe el evento...',
      organizer: 'Soy el organizador de este evento',
      save: 'Guardar cambios',
      create: 'Crear evento',
      required: 'Obligatorio',
    },
    addToCalendar: 'Añadir al calendario',
    share: {
      title: 'Mira este evento',
      message: 'Mira {{eventName}}',
      shareEvent: 'Compartir evento',
    },
  },
  post: {
    like_one: '{{count}} me gusta',
    like_other: '{{count}} me gustas',
    comment_one: '{{count}} comentario',
    comment_other: '{{count}} comentarios',
    addComment: 'Comentar',
    announcement: 'Anuncio',
    singlePost: 'Publicación',
    newPost: 'Nueva publicación',
    placeholder: '¿Qué estás pensando?',
    compose: {
      wallPlaceholder: 'Escribe en el muro de {{userName}}...',
    },
    publish: 'Publicar',
    createSuccess: 'Tu publicación ha sido publicada',
    createError: 'Error al publicar la publicación',
    editSuccess: 'Tu publicación ha sido actualizada',
    editError: 'Error al actualizar la publicación',
    readMore: 'Leer más',
    featuredPhoto: {
      warningWithReset:
        'Parece que publicaste otra foto muy recientemente, lo que significa que esta foto no se destacará en el feed global, a menos que esperes {{minutes}} minutos para publicarla',
    },
    menu: {
      edit: 'Editar la publicación',
      dismissAnnouncement: 'Ocultar el anuncio',
      share: 'Compartir la publicación',
      stopNotifications: 'Desactivar notificaciones',
      resumeNotifications: 'Reanudar notificaciones',
      report: 'Denunciar la publicación',
      delete: 'Eliminar la publicación',
    },
    mute: {
      title: '¿Desactivar notificaciones por cuánto tiempo?',
      oneHour: '1 hora',
      eightHours: '8 horas',
      oneDay: '24 horas',
      indefinitely: 'Indefinidamente',
      success: 'Notificaciones para esta publicación desactivadas con éxito',
      error: 'Error al desactivar las notificaciones para esta publicación',
    },
    unmute: {
      success: 'Notificaciones para esta publicación reanudadas con éxito',
      error: 'Error al reanudar las notificaciones para esta publicación',
    },
    getMutedState: {
      error: 'Error al obtener el estado de las notificaciones',
    },
    dismissAnnouncement: {
      success: 'Anuncio ocultado',
      error: 'Error al ocultar el anuncio',
    },
    delete: {
      confirmTitle: 'Eliminar publicación',
      confirmMessage:
        '¿Estás seguro de que quieres eliminar la publicación? Esta acción no se puede deshacer.',
      success: 'Publicación eliminada con éxito',
      error: 'Error al eliminar la publicación',
    },
    share: {
      title: 'Compartir publicación',
      message: 'Mira esta publicación de {{userName}}',
      success: 'Publicación compartida con éxito',
      copied: 'Enlace copiado al portapapeles',
      error: 'Error al compartir la publicación',
      shareLink: 'Compartir enlace',
      copy: 'Copiar',
      open: 'Abrir',
      postUrl: 'URL de la publicación',
    },
  },
  media: {
    gif_button_label: 'Agregar un GIF',
    no_results: 'No se encontraron GIFs',
    failed_to_load: 'No se pudo cargar el GIF',
    search_placeholder: 'Buscar en {{provider}}',
    powered_by: 'Con tecnología de {{provider}}',
  },
  comments: {
    title: 'Comentarios',
    titleOnItem: 'Comentarios en {{itemType}} de {{userName}}',
    empty: '¡Sé el primero en comentar!',
    add_placeholder: 'Añadir un comentario...',
    added: 'Tu comentario ha sido publicado',
    add_error: 'Error al publicar el comentario',
    editSuccess: 'Tu comentario ha sido actualizado',
    editError: 'Error al actualizar el comentario',
    menu: {
      edit: 'Editar el comentario',
      report: 'Denunciar el comentario',
      delete: 'Eliminar el comentario',
    },
    delete: {
      confirmTitle: 'Eliminar comentario',
      confirmMessage:
        '¿Estás seguro de que quieres eliminar el comentario? Esta acción no se puede deshacer.',
      success: 'Comentario eliminado con éxito',
      error: 'Error al eliminar el comentario',
    },
    viewMore_one: 'Ver {{count}} comentario mas',
    viewMore_other: 'Ver {{count}} comentarios mas',
  },
  likes: {
    title: 'Me gustas',
    titleOnItem: 'Me gustas en {{itemType}} de {{userName}}',
  },
  notifications: {
    title: 'Notificaciones',
    titleNative: 'Notificaciones push',
    empty: 'Aún no hay notificaciones',
    newNotifications: 'Nuevas notificaciones',
    clearAll: 'Borrar todas',
    clearAllConfirmTitle: 'Borrar notificaciones',
    clearAllConfirmMessage:
      'Esto descartará todas tus notificaciones, incluidas las solicitudes pendientes de acceso a tus fotos privadas. ¿Continuar?',
    clearAllSuccess: 'Notificaciones borradas',
    clearAllError: 'No se pudieron borrar las notificaciones',
    dismiss: 'Descartar notificación',
    dismissSuccess: 'Notificación descartada',
    dismissError: 'No se pudo descartar la notificación',
    andOthers_one: '(y {{count}} más)',
    andOthers_other: '(y {{count}} más)',
    unlockAcceptSuccess: 'Solicitud de desbloqueo aceptada',
    unlockAcceptError: 'Error al aceptar la solicitud de desbloqueo',
    unlockRejectSuccess: 'Solicitud de desbloqueo rechazada',
    unlockRejectError: 'Error al rechazar la solicitud de desbloqueo',
    permissionDisabledTitle: 'Las notificaciones push están desactivadas',
    permissionDisabledDescription:
      'Activa las notificaciones en los ajustes para no perderte ninguna actividad.',
    openSettings: 'Abrir ajustes',
  },
  settings: {
    title: 'Configuración',
    appearance: 'Apariencia',
    location: {
      title: 'Ubicación',
      current: 'Publicado como',
      mode: 'Nombre del lugar',
      fixed: 'Fijo',
      automatic: 'Automático',
      enable: 'Activar ubicación...',

      enableHelp: 'Activar ubicación',
      enableHelpBlocked: 'Tu navegador esta bloqueando el acceso a tu ubicación',
      enableHelpSteps:
        'Para activarla, sigue los pasos a continuación:\n\n\u2022 Abre el menu de información del sitio cerca de la barra de direcciones (icono de candado, configuración o información).\n\u2022 Busca los permisos de este sitio y localiza la configuración de ubicación.\n\u2022 Cambia la ubicación a Permitir (o Preguntar cada vez).\n\u2022 Recarga la pagina.',
      tips: 'Consejos y privacidad',
      fixedSet: 'Ubicación publicada actualizada',
      fixedError: 'No se pudo establecer la ubicación',
      searchPlaceholder: 'Ciudad, código postal o dirección',
      searchHint: 'Escribe al menos 2 caracteres',
      noResults:
        'No hay lugares coincidentes. Revisa la ortografía o prueba con una ciudad cercana.',
      searchError: 'Error al buscar lugares',
      pickPlace: 'Elige un lugar',
      autoDescription:
        'El nombre del lugar (ciudad) que aparece en tu perfil se actualizará a medida que viajes',
    },
    account: {
      title: 'Cuenta',
      username: {
        title: 'Cambiar nombre de usuario',
        title_short: 'Nombre de usuario',
        label: 'Nuevo nombre de usuario',
        placeholder: 'Ingresa nuevo nombre de usuario',
        helper:
          'Elige un nuevo nombre de usuario de 2 a 20 caracteres que comience con una letra. Solo se permiten letras, dígitos, - y _.',
        invalid: 'Nombre de usuario inválido',
        unavailable: 'Este nombre de usuario ya está en uso',
        current: 'Usuario:',
        updateAndSignOut: 'Actualizar y cerrar sesión',
        successSignOut:
          'Nombre de usuario actualizado. Vuelve a iniciar sesión con tu nuevo nombre de usuario.',
        error: 'No se pudo actualizar el nombre de usuario',
      },
      email: {
        title: 'Cambiar correo electrónico',
        title_short: 'Correo electrónico',
        label: 'Nuevo correo electrónico',
        placeholder: 'Ingresa nuevo correo electrónico',
        changeExplanation:
          'Enviaremos un enlace de confirmación a tu nuevo correo. Se actualizará después de confirmar.',
        invalid: 'Ingresa un correo electrónico válido',
        unavailable: 'Este correo ya está en uso',
        current: 'Correo:',
        success: 'Cambio de correo solicitado. Revisa tu bandeja para confirmar.',
        error: 'No se pudo actualizar el correo',
      },
      password: {
        title: 'Cambiar contraseña',
        change: 'Cambiar contraseña',
        old: 'Contraseña actual',
        new: 'Nueva contraseña (mín. 6 caracteres)',
        repeat: 'Repite la nueva contraseña',
        mismatch: 'Las contraseñas no coinciden',
        oldRequired: 'Ingresa tu contraseña actual',
        success: 'Contraseña actualizada',
        error: 'No se pudo actualizar la contraseña',
      },
      delete: {
        title: 'Eliminar cuenta',
        confirmLabel: 'Confirma con tu contraseña actual',
        confirmMessage: 'Esta acción es permanente. Escribe tu contraseña para confirmar.',
        placeholder: 'Ingresa la contraseña actual',
        submit: 'Eliminar mi cuenta',
        required: 'Ingresa tu contraseña actual',
        success: 'Tu cuenta ha sido eliminada',
        error: 'No se pudo eliminar la cuenta',
      },
    },
    privacy: {
      title: 'Privacidad y Seguridad',
      blockedMembers: 'Miembros bloqueados',
      photoUnlockAuthorized: 'Autorizaciones de fotos privadas',
      emptyHelp: {
        blocked:
          'Los miembros que bloquees aparecerán aquí. Puedes quitar los bloqueos cuando quieras.',
        photoUnlockAuthorized:
          'Aquí aparecerán los miembros a los que diste acceso a tus fotos privadas. Puedes revocar el acceso en cualquier momento.',
      },
      removeUnlock: {
        title: 'Quitar acceso',
        action: 'Quitar acceso',
        confirmMessage: '¿Quitar el acceso a tus fotos privadas para {{userName}}?',
        success: 'Acceso quitado',
        error: 'Error al quitar el acceso',
      },
    },
    language: 'Idioma',
    system: 'Igual que el sistema',
    community: 'Comunidad',
    pattern: 'Patrón de encabezado',
    patterns: {
      none: 'Ninguno',
      bones: 'Huesos y patas',
      circles: 'Círculos',
      food: 'Comida',

      japanese: 'Japonés',
      plaid: 'Cuadros',
      polygonal: 'Poligonal',
      sprinkles: 'Chispas',
      stars: 'Estrellas',
      triangles: 'Triángulos',
    },
    appIcon: {
      title: 'Icono de la app',
      description: 'Elige el icono que aparece en tu pantalla de inicio.',
      changed: 'Icono de la app actualizado',
    },
    theme: {
      title: 'Tema',
      auto: 'Igual que el sistema',
      light: 'Modo claro',
      dark: 'Modo oscuro',
    },
    units: {
      title: 'Unidades',
      distance: 'Distancia',
      distanceKm: 'Kilómetros (km)',
      distanceMi: 'Millas (mi)',
      height: 'Altura',
      heightM: 'Metros (m)',
      heightFt: 'Pies (ft)',
      weightUnit: 'Peso',
    },
    diagnostics: {
      title: 'Herramientas de diagnóstico',
      signalr: 'Diagnóstico de SignalR',
      clearCache: 'Limpiar caché',
      cacheCleared: 'Caché limpiada correctamente',
    },
    preferences: {
      title: 'Preferencias',
      birthdayList: 'Lista de cumpleaños',
      birthdayListDescription: 'Mostrarme en la lista de cumpleaños',
      anonymousViewing: 'Visualización anónima',
      anonymousViewingDescription: 'Navegar perfiles sin aparecer en la lista de visitantes',
      inboundMessagePhotos: 'Fotos entrantes',
      inboundMessagePhotosDescription:
        'Permitir fotos en DMs de cualquiera (si no, solo de personas que sigues)',
      emailNotifications: 'Notificaciones por correo',
      emailNotificationsDescription: 'Recibir correos para mensajes nuevos',
      photosInNewsfeed: 'Fotos en noticias',
      photosInNewsfeedDescription: 'Mostrar publicaciones con fotos en noticias globales',
      mediaInComments: 'Mostrar GIFs en comentarios',
      mediaInCommentsDescription:
        'Muestra GIFs y otros medios en comentarios de publicaciones y fotos.',
      safeModeOff: 'Medios sensibles y sin revisar',
      safeModeOffDescription: 'Mostrar medios que pueden contener contenido sensible (NSFW)',
    },
    safety: {
      title: 'Opciones de seguridad',
    },
    notifications: {
      title: 'Notificaciones',
      titleWithSounds: 'Notificaciones y sonidos',
      description: 'Elige qué actividades generan notificaciones push',
      futureNotifications:
        'Las siguientes notificaciones push están planificadas para implementación futura y no están activas actualmente.',
      newMessage: 'Mensajes nuevos',
      newMessageDescription: 'Cuando alguien te envíe un mensaje',
      newFollower: 'Nuevos seguidores',
      newFollowerDescription: 'Cuando alguien te siga',
      newPhotoComment: 'Comentarios en fotos',
      newPhotoCommentDescription: 'Cuando alguien comente tus fotos',
      newPostComment: 'Comentarios en publicaciones',
      newPostCommentDescription: 'Cuando alguien comente tus publicaciones',
      newWallPost: 'Publicaciones en muro',
      newWallPostDescription: 'Cuando alguien publique en tu muro',
      web: {
        mobileTitle: 'Las notificaciones push no están disponibles en la web',
        mobileSubtitle:
          'Instala la app de iOS o Android para recibir notificaciones push cuando alguien te escriba o interactúe con tu contenido.',
        soundsDescription:
          'Elige un sonido para cuando llegue algo nuevo. Los sonidos los reproduce tu navegador, así que mantén abierta la pestaña de {{communityName}}.',
        messageSoundLabel: 'Sonido de nuevo mensaje',
        notificationSoundLabel: 'Sonido de nueva notificación',
        preview: 'Probar sonido',
        appStoreButton: 'Descargar en App Store',
        googlePlayButton: 'Disponible en Google Play',
      },
      sounds: {
        off: 'Desactivado',
        trill: 'Trino',
        stepUp: 'Subida',
        bubblePop: 'Pop de burbuja',
        marimba: 'Marimba',
        metro: 'Metro',
        retro: 'Retro',
        sparkle: 'Destello',
        strings: 'Cuerdas',
      },
    },
    dangerZone: 'Zona de peligro',
    about: {
      title: 'Acerca de esta app',
      version: 'Versión',
      build: 'compilación',
      madeWithCities: 'Hecho con ❤️ en Montreal, Nueva York y San Francisco',
      whatsNew: 'Novedades de esta versión',
    },
  },
  whatsNew: {
    title: 'Novedades',
    currentReleaseTitle: 'En esta versión',
    catchUpReleaseTitle: 'Desde la ultima actualizacion',
    recentUpdatesTitle: 'Actualizaciones recientes',
    lineageLabel: 'Versión {{lineage}}',
    empty: 'No hay novedades para mostrar.',
    neverShowAgain: 'No volver a mostrar',
    showOnNewVersions: 'Mostrar esta pantalla en nuevas versiones',
  },
  upgrade: {
    prompt: 'Obtén fotos de tamaño completo en tu feed sin límite diario',
    upgrade_button: 'Obtener Premium',
  },
  premium: {
    upgradeCard: {
      photos: '...¡y muchas más! Actualiza a {{premiumPlan}} para ver todas las fotos.',
      members: '...¡y muchos más! Actualiza a {{premiumPlan}} para ver todos los miembros.',
      conversation:
        'Actualiza a {{premiumPlan}} para acceder a todo tu historial de conversaciones.',
    },
  },
  paywall: {
    ViewFullsizePhoto:
      'Límite actual alcanzado para ver fotos de tamaño completo. Actualiza a {{premiumPlanName}} para acceso ilimitado.',
    OutgoingCommunication:
      'Límite actual alcanzado para enviar mensajes y publicaciones. Actualiza a {{premiumPlanName}} para comunicación ilimitada.',
    NewsfeedSearch:
      'Límite actual alcanzado para búsquedas en el feed. Actualiza a {{premiumPlanName}} para búsquedas ilimitadas.',
    ValidateGiftCertificate: 'Límite actual alcanzado para validaciones de certificados de regalo.',
    Blocks:
      'Has alcanzado el número máximo de miembros bloqueados. Actualiza a {{premiumPlanName}} para más bloqueos.',
    BlockingAMember:
      'Recientemente bloqueaste o desbloqueaste a este miembro. Por favor espera 3 días antes de bloquearlo o desbloquearlo nuevamente.',
    PostsPerHour:
      'Has alcanzado tu límite de publicaciones por hora. Por favor espera antes de publicar nuevamente.',
    ChangeOfEmail:
      'Límite actual alcanzado para solicitudes de cambio de correo electrónico. Por favor intenta mañana.',
    PhotoStream:
      'Límite actual alcanzado para ver transmisiones de fotos. Actualiza a {{premiumPlanName}} para acceso ilimitado.',
    FeaturedPhotos:
      'Solo puedes destacar una foto en el feed global por hora. Por favor espera antes de publicar otra.',
    PhotoUnlockRequests:
      'Límite actual alcanzado para solicitudes de desbloqueo de fotos. Actualiza a {{premiumPlanName}} para solicitudes ilimitadas.',
    AnonymousViewing:
      'La visualización anónima requiere una membresía {{premiumPlanName}}. Actualiza para navegar perfiles sin aparecer en las listas de visitantes.',
    PostsPerDay: 'Has alcanzado tu límite de publicaciones diarias. Por favor intenta mañana.',
    UploadedPhotos:
      'Has alcanzado tu límite de fotos. Actualiza a {{premiumPlanName}} para subir más fotos.',
    UploadedPhotosPerDay:
      'Has alcanzado tu límite diario de subida de fotos. Actualiza a {{premiumPlanName}} para subir más fotos hoy.',
    MemberSearch:
      'Has alcanzado el límite diario de búsquedas. Actualiza a {{premiumPlanName}} para búsquedas ilimitadas.',
    MyTypeFilterChange:
      'Has alcanzado el límite diario para cambiar tu filtro de tipo. Actualiza a {{premiumPlanName}} para cambiarlo cuando quieras.',
    default: 'Esta función requiere una cuenta {{premiumPlanName}}. Actualiza para continuar.',
    resetIn: {
      minutes_one: 'Intentar de nuevo en {{count}} minuto',
      minutes_other: 'Intentar de nuevo en {{count}} minutos',
      hours_one: 'Intentar de nuevo en {{count}} hora',
      hours_other: 'Intentar de nuevo en {{count}} horas',
    },
  },
  notFound: {
    title: 'Lo sentimos, no podemos encontrar lo que estás buscando.',
    goHome: 'Volver a la pantalla de inicio',
  },
  communitiesHeader: {
    title: 'Comunidades',
  },
  profile: {
    aboutMe: 'Sobre mí',
    stats: 'Estadísticas',
    bio: 'Biografía',
    height: 'Altura',
    weight: 'Peso',
    gender: 'Género',
    origin: 'Origen',
    relationship: 'Relación',
    languages: 'Idiomas',
    interestedIn: 'Interesado en',
    preferences: 'Preferencias',
    lookingFor: 'Busca',
    bodyTypesLiked: 'Tipos de cuerpo',
    bodyPartsLiked: 'Características corporales',
    sexualInterests: 'Intereses sexuales',
    mutualKinks: 'Fetiches mutuos',
    // Shared field labels (used by search, profile view, and edit profile)
    identifyAs: 'Se identifica como',
    relationshipStatus: 'Estado de relación',
    bodyTypes: 'Tipos de cuerpo',
    bodyHair: 'Vello corporal',
    facialHair: 'Vello facial',
    communityKinks: 'Fetiches de la comunidad',
    otherKinks: 'Otros fetiches',
    // Section titles
    sections: {
      identity: 'Identidad y antecedentes',
      interestsAndKinks: 'Intereses y fetiches',
      bodyFeatures: 'Tipos de cuerpo y características',
    },
    // Units
    units: {
      weight: {
        pounds: 'Libras (lb)',
        kilograms: 'Kilogramos (kg)',
        stones: 'Stones (st)',
        short: {
          lb: 'lb',
          kg: 'kg',
          st: 'st',
        },
        suffix: {
          lbs: 'lbs',
          kg: 'kg',
          st: 'st',
        },
      },
      height: {
        feet: 'Pies (ft)',
        meters: 'Metros (m)',
        short: {
          ft: 'ft',
          m: 'm',
        },
        suffix: {
          m: 'm',
        },
      },
    },
    lastSeen: 'Visto por última vez',
    lastVisitedYou: 'Vio tu perfil',
    notYet: 'Aún no',
    activity: 'Actividad',
    joinDateWithCommunity: 'En {{communityName}} desde',
    seeAllPhotos: 'Ver todo',
    followers: 'seguidores',
    followers_one: 'seguidor',
    followers_other: 'seguidores',
    following: 'siguiendo',
    following_one: 'siguiendo',
    following_other: 'siguiendo',
    follows_you: 'Te sigue',
    followersCount_one: '{{count}} seguidor',
    followersCount_other: '{{count}} seguidores',
    followingCount: '{{count}} siguiendo',
    followersOfUser: 'Seguidores de {{userName}}',
    followingOfUser: '{{userName}} está siguiendo',
    tabs: {
      about: 'Acerca de',
      posts: 'Publicaciones',
      photos: 'Fotos',
      events: 'Eventos',
      weight: 'Peso',
      wall: 'Muro',
    },
    photos: {
      public: 'Públicas',
      private: 'Privadas',
      privateLocked: 'Las fotos privadas están bloqueadas',
      requestAccess: 'Solicitar acceso',
      extendedPreviewNotice: 'Puedes ver más fotos porque este miembro tiene {{premiumPlan}}.',
      requestPending: 'Tu solicitud para acceder a las fotos privadas está pendiente de aprobación',
      requestSubmitted: 'Solicitud de acceso enviada',
      requestFailed: 'Error al enviar la solicitud de acceso',
    },
    wall: {
      empty: 'No hay publicaciones que mostrar',
    },
    share: {
      title: 'Compartir perfil',
      message: 'Mira el perfil de {{userName}}',
      shareProfile: 'Compartir perfil',
    },
  },
  member: {
    notFound: 'Miembro no encontrado',
    menu: {
      report: 'Reportar miembro',
      block: 'Bloquear miembro',
      unblock: 'Desbloquear miembro',
      privatePhotosSection: 'Fotos privadas',
      revokePrivatePhotos: {
        action: 'Revocar acceso',
        confirmTitle: 'Revocar acceso',
        confirmMessage:
          '{{userName}} ya no podrá ver tus fotos privadas. Podrá enviarte una nueva solicitud más adelante.',
        success: 'Acceso revocado',
        error: 'No se pudo revocar el acceso',
      },
      forfeitPrivatePhotos: {
        action: 'Cancelar suscripción',
        confirmTitle: 'Cancelar suscripción',
        confirmMessage:
          'Ya no podrás ver las fotos privadas de {{userName}}. Puedes solicitar acceso de nuevo más adelante.',
        success: 'Suscripción cancelada',
        error: 'No se pudo cancelar la suscripción',
      },
    },
    block: {
      confirmMessage:
        '¿Estás seguro de que quieres bloquear a {{userName}}? Esta acción no se puede deshacer durante las próximas 72 horas para prevenir acoso.',
      success: 'Miembro bloqueado exitosamente',
      error: 'Error al bloquear miembro',
    },
    unblock: {
      confirmMessage:
        '¿Estás seguro de que quieres desbloquear a {{userName}}? Esta acción no se puede deshacer durante las próximas 72 horas para prevenir acoso.',
      success: 'Miembro desbloqueado exitosamente',
      error: 'Error al desbloquear miembro',
    },
    unfollow: {
      confirmTitle: 'Dejar de seguir',
      confirmMessage: '¿Estás seguro de que quieres dejar de seguir a {{userName}}?',
      success: 'Ya no sigues a {{userName}}',
      error: 'Error al dejar de seguir al miembro',
    },
    follow: {
      success: 'Ahora sigues a {{userName}}',
      error: 'Error al seguir al miembro',
    },
    locked: {
      message: 'Actualiza a {{premiumPlan}} para explorar perfiles de miembros ilimitados.',
    },
  },
  userMenu: {
    viewProfile: 'Ver mi perfil',
    editProfile: 'Editar mi perfil',
    settings: 'Configuración',
    plans: 'Planes y suscripción',
    help: 'Ayuda y soporte',
    feedback: 'Feedback',
    rules: 'Reglas de la comunidad',
    browseCommunities: 'Explorar comunidades',
    signOut: 'Cerrar sesión',
  },
  editProfile: {
    title: 'Editar perfil',
    saveSuccess: 'Perfil actualizado correctamente',
    saveError: 'Error al actualizar el perfil',
    loadError: 'Error al cargar el perfil',
    saving: 'Guardando...',
    sections: {
      basicInfo: 'Información básica',
    },
    firstName: 'Nombre',
    firstNamePlaceholder: 'Ingresa tu nombre',
    birthDate: 'Fecha de nacimiento',
    selectYear: 'Seleccionar año',
    selectMonth: 'Seleccionar mes',
    selectDay: 'Seleccionar día',
    selectHeight: 'Seleccionar altura',
    weightGoal: 'Peso objetivo',
    weightRangeError: 'El peso debe estar dentro del rango permitido',
    descriptionPlaceholder: 'Cuéntanos sobre ti...',
    textPlaceholder: 'Ingresa texto...',
    notSet: 'No establecido',
    identifyAs: 'Me identifico como',
    myBodyType: 'Mi tipo de cuerpo',
    bodyTypesLiked: 'Tipos de cuerpo que me gustan',
    bodyPartsLiked: 'Características físicas que me gustan',
    myBodyHair: 'Mi vello corporal',
    myFacialHair: 'Mi vello facial',
    hints: {
      firstName: 'Opcional. Aparece en tu perfil después de tu nombre de usuario.',
      birthDate:
        'No es visible para otros usuarios. Se usa para verificar que eres adulto y mostrar tu edad.',
      bio: 'Cuéntale a otros sobre ti, lo que te gusta y lo que buscas.',
    },
  },
  account: {
    plans: {
      title: 'Planes y suscripción',
      includedWith: '¿Qué está incluido con {{planName}}?',
      choosePlan: 'Elige tu plan',
      terms: 'Términos',
      bestValue: 'MEJOR VALOR',
      monthlyPlan: 'Plan Mensual {{planName}}',
      yearlyPlan: 'Plan Anual {{planName}}',
      regularPrice: 'Precio regular',
      perMonth: 'por mes',
      perYear: 'por año',
      onlyPerMonth: 'Solo {{price}}/mes (ahorra {{percent}}%)',
      pricesIn: 'Precios en {{currency}}.',
      billingTerms_ios:
        'El pago se cargará a tu cuenta de Apple al confirmar la compra. Los planes son válidos por el período que selecciones y se renovarán automáticamente al precio indicado a menos que se cancelen al menos 24 horas antes del final del período actual. Puedes cancelar tu suscripción en cualquier momento en la configuración de tu dispositivo o usando Administrar Suscripción arriba.',
      billingTerms_android:
        'El pago se cargará a tu cuenta de Google al confirmar la compra. Los planes son válidos por el período que selecciones y se renovarán automáticamente al precio indicado a menos que se cancelen al menos 24 horas antes del final del período actual. Puedes cancelar tu suscripción en cualquier momento en la configuración de tu dispositivo o usando Administrar Suscripción arriba.',
      billingTerms_web:
        'Los términos de suscripción y los detalles de facturación se proporcionarán al finalizar la compra. Tu suscripción se renovará automáticamente a menos que se cancele antes de la fecha de renovación.',
      privacyPolicy: 'Política de Privacidad',
      termsOfUse: 'Términos de Uso',
      manageSubscription: 'Gestionar suscripciones',
      currentPlan: 'Plan Actual',
      loading: 'Cargando planes...',
      confirming: 'Confirmando tu suscripción...',
      connecting: 'Conectando a la tienda...',
      connectionError: 'Error de Conexión',
      openPlayStore: 'Abrir Play Store',
      signInToPlayStore: 'Inicia sesión en Google Play Store para continuar',
      openAppStore: 'Abrir App Store',
      checkAppStoreConnection: 'Verifica tu conexión con App Store e intenta de nuevo',
      premiumFeatures: {
        unlimitedPhotos: 'Visualización ilimitada de fotos',
        featureMorePhotosToRegularMembers: 'Muestra más de tus fotos a miembros sin suscripción',
        unlimitedMessaging: 'Mensajería ilimitada',
        moreBlocks: 'Más bloqueos',
        morePhotoUploads: 'Más subidas de fotos',
      },
      learnMoreAboutPlans: 'Descubre todo sobre nuestros planes',
      yourAccountIsOn: 'Tu cuenta está en el plan {{planName}}',
      currentCreditsUntil: 'Créditos actuales vigentes hasta:',
      daysLeft_one: '{{count}} día restante',
      daysLeft_other: '{{count}} días restantes',
      hoursLeft_one: '{{count}} hora restante',
      hoursLeft_other: '{{count}} horas restantes',
      subscriptionRenewalNote:
        'Tu suscripción se renueva automáticamente según tu ciclo de facturación. Cada renovación añade créditos a tu cuenta. Los créditos de promociones o certificados de regalo pueden extenderse más allá del período de suscripción actual. ¡Gracias por ser miembro de {{planName}}!',
      billingNotAvailable: 'Las suscripciones no están disponibles actualmente',
      grandfatheredPricing:
        '¡Felicidades! Has sido beneficiado con nuestros precios anteriores más bajos.',
      oneMonth: 'Mensual',
      threeMonths: 'Trimestral',
      oneYear: 'Anual',
      oneYearCombo: 'Anual Dúo',
      comboSubtitle: 'Incluye Grommr XL y 1 año de Chasable+ (certificado de regalo)',
      every3Months: 'cada 3 meses',
      save: 'ahorra {{percent}}%',
      renewsEveryDays: 'Se renueva automáticamente cada {{days}} días',
      subscribe: 'Suscribirme',
      subscribed: 'Suscrito',
      manageCCBill: 'Cancelar/gestionar una suscripción de CCBill',
      subscriptionIdLabel: 'Tu ID de suscripción más reciente de CCBill',
      subscriptionIdCopied: 'ID de suscripción copiado al portapapeles',
      ccbillPayments: 'Pagos de CCBill (Suscripciones)',
      ccbillDescription:
        'Usamos CCBill para gestionar nuestra facturación y hay varias formas de comprar tu pase con tarjeta de crédito: Aceptamos Visa, Mastercard, JCP y Discover. Tu extracto de tarjeta de crédito mostrará "CCBill.Com *Grokio" (Grokio Communities LLC es la empresa operadora detrás de {{communityName}}). Tienes la opción de realizar tu transacción en una de cinco monedas: USD; EUR; GBP; CAD; AUD; y JPY. Tan pronto como recibamos la confirmación de que se realizó el pago, el nuevo tiempo se agregará a tu cuenta (en la mayoría de los casos esto debería ser inmediato). Todas las suscripciones a través de CCBill se renuevan automáticamente. Si deseas cancelar tu suscripción, puedes usar el enlace proporcionado y cancelarla al menos 48 horas antes de que se renueve.',
      billingFaq: 'Información de Facturación y Preguntas Frecuentes',
      billingFaqDescription:
        'Consulta nuestro documento de Información de Facturación de {{planName}} para obtener detalles sobre pagos, renovaciones y cancelaciones.',
      billingFaqGuide: 'Guía de {{planName}}',
      getBillingSupport: 'Obtener soporte de facturación',
      restorePurchases: 'Restaurar compras',
      error: {
        loadProducts: 'Error al cargar los planes de suscripción',
        noProductsFound: 'No se encontraron productos de suscripción',
        purchase: 'Compra fallida',
        purchasePayment:
          'Tu compra no pudo completarse. Verifica tu método de pago e intenta nuevamente.',
        purchaseNetwork:
          'No se pudo conectar a la tienda. Verifica tu conexión a internet e intenta nuevamente.',
        purchaseUnavailable:
          'Las compras dentro de la app no están disponibles en este dispositivo o cuenta.',
        purchaseAlreadyOwned: 'Ya tienes una suscripción activa para este plan.',
        purchaseDeferred:
          'Tu pago está pendiente de aprobación. La suscripción se activará una vez aprobado.',
        purchaseItemUnavailable: 'Este plan de suscripción no está disponible actualmente.',
        validation: 'Error al validar la compra',
        restore: 'No se pudieron restaurar — inténtalo de nuevo o contacta con soporte',
        restoreUnavailable:
          'No se puede conectar con la tienda. Comprueba tu conexión e inténtalo de nuevo.',
      },
      success: {
        subscribedWithPlan: '¡Gracias por suscribirte! Tu plan {{planName}} está ahora activo.',
        subscribedWithBogo:
          '¡Gracias por suscribirte! Tu {{planName}} está ahora activo. Bonificación: ¡Ganaste un {{period}} extra con nuestra promoción!',
        restored: 'Compras restauradas exitosamente',
        nothingToRestore: 'No hay compras que restaurar',
      },
    },
    transactions: {
      title: 'Historial de transacciones',
      empty: 'No hay transacciones todavía',
      days_one: 'día',
      days_other: 'días',
      header: {
        date: 'Fecha',
        description: 'Descripción',
      },
    },
    certificates: {
      title: 'Certificados de Regalo',
      history: 'Tus certificados de regalo',
      empty: 'No hay certificados de regalo todavía',
      purchase: 'Compra de Certificado de Regalo',
      redeemed: 'Certificado de Regalo Canjeado',
      redeemedOn: 'Canjeado el {{date}}',
      codeCopied: 'Código del certificado copiado al portapapeles',
      redeem: {
        title: 'Canjear un certificado de regalo',
        helper: 'Ingresa el código que recibiste para añadir tiempo premium a tu cuenta.',
        placeholder: 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX',
        button: 'Canjear',
        success_one: '¡Certificado de regalo canjeado! Se añadió {{count}} día a tu cuenta.',
        success_other: '¡Certificado de regalo canjeado! Se añadieron {{count}} días a tu cuenta.',
        invalidFormat: 'Esto no parece un código de certificado de regalo. Los códigos tienen 25 letras y números.',
        notFound: 'No encontramos este código. Asegúrate de canjearlo en la comunidad para la que fue emitido.',
        alreadyRedeemed: 'Este certificado de regalo ya fue canjeado.',
        tooManyAttempts: 'Demasiados intentos. Vuelve a intentarlo mañana.',
        error: 'No pudimos canjear este certificado de regalo. Inténtalo más tarde.',
      },
      header: {
        date: 'Fecha',
        details: 'Detalles',
      },
    },
  },
  webDrop: {
    dropToUpload: 'Suelta la imagen para subir',
    dragHint: 'Arrastra aquí una imagen JPG/PNG',
  },
  weightHistory: {
    stats: 'Estadísticas',
    currentWeight: 'Actual',
    trend: 'Tendencia',
    bmi: 'IMC',
    goal: 'Meta',
    perMonth: '/mes',
    history: 'Historial',
    date: 'Fecha',
    weight: 'Peso',
    notes: 'Notas',
    noData: 'Aún no hay registros de peso',
    noChartData: 'No hay suficientes datos para el gráfico',
    addRecord: 'Agregar',
    editRecord: 'Editar peso',
    selectDate: 'Seleccionar fecha',
    notesPlaceholder: 'Notas opcionales...',
    added: 'Peso agregado',
    updated: 'Peso actualizado',
    deleted: 'Registro de peso eliminado',
    saveFailed: 'Error al guardar',
    deleteFailed: 'Error al eliminar el registro',
    deleteTitle: 'Eliminar',
    deleteConfirm: '¿Eliminar este registro de peso?',
  },
  footer: {
    support: 'Soporte',
    terms: 'Términos de uso',
    privacy: 'Política de privacidad',
  },
  report: {
    reasonTitle: '¿Por qué denuncias esto?',
    rulesLink: 'Lee las Normas de la comunidad',
    reasons: {
      scam: 'Estafador',
      spam: 'Spam',
      falsePortrayal: 'Identidad falsa',
      harassment: 'Acoso',
      intolerance: 'Intolerancia',
      trolling: 'Troleo',
      disparagement: 'Desprestigio',
      donationRequest: 'Petición de donaciones',
      promotionalPosting: 'Infracción de publicación promocional',
      photoPolicy: 'Infracción de la política de fotos',
      uncreditedArtwork: 'Arte sin crédito',
      underage: 'Menor de edad',
      illegalActivity: 'Otras actividades ilegales',
      other: 'Otro',
    },
  },
};
